import AbstractRepository from "@/repositories/AbstractRepository";

export default class ListSfLeverRepository extends AbstractRepository {
    protected static resource: string = "ptf-monocle-creativegroupformatformdefinition";

    protected static defaultFields: string[] = [
        "uuid",
        "label",
    ];
}
